import { OauthAuthorizeResponseDto } from '../interfaces/oauth-authorize-response-dto';

/** Адрес, куда уходит браузер после «Разрешить». */
export function mapOauthAuthorizeResponseDto(dto: OauthAuthorizeResponseDto): string {
  return dto.redirect_url;
}
